module.exports = __webpack_public_path__ + "static/media/MATIC.da065340.svg";